import CallButton from "pages/admin/driverRequest/instanceModal/status/callButton";
import { useRouteMatch } from "react-router-dom";

interface IProps {
  id?: number;
  phone: string;
}

export default function AtpCallButton(props: IProps) {
  const {
    id,
    phone,
  } = props;
  const match: any = useRouteMatch();
  const atp = match.params.id;
  return (
    <CallButton
      id={id}
      phone={phone}
      atp_id={atp}
    />
  )
}